var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCard = function SvgCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#card_svg__a)",
    fillRule: "evenodd",
    d: "M17.857 11.178c0 2.222 0 3.333-.69 4.024-.691.69-1.802.69-4.025.69H6.857c-2.222 0-3.334 0-4.024-.69s-.69-1.802-.69-4.024V9.695h15.714v1.483Zm-11.786.699a.873.873 0 0 0 0 1.746h.008a.874.874 0 0 0 0-1.746H6.07Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#card_svg__b)",
    fillRule: "evenodd",
    d: "M17.857 11.178c0 2.222 0 3.333-.69 4.024-.691.69-1.802.69-4.025.69H6.857c-2.222 0-3.334 0-4.024-.69s-.69-1.802-.69-4.024V9.695h15.714v1.483Zm-11.786.699a.873.873 0 0 0 0 1.746h.008a.874.874 0 0 0 0-1.746H6.07Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#card_svg__c)",
    d: "M13.143 4.107c2.222 0 3.333 0 4.023.69.594.594.673 1.498.685 3.151H2.149c.011-1.653.091-2.557.684-3.15.69-.69 1.802-.691 4.024-.691h6.285Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#card_svg__d)",
    d: "M13.143 4.107c2.222 0 3.333 0 4.023.69.594.594.673 1.498.685 3.151H2.149c.011-1.653.091-2.557.684-3.15.69-.69 1.802-.691 4.024-.691h6.285Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "card_svg__a",
    x1: 4.558,
    x2: 14.738,
    y1: 14.749,
    y2: 1.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#636F7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADDE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "card_svg__b",
    x1: 4.558,
    x2: 14.738,
    y1: 14.749,
    y2: 1.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#0DD149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3F4D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "card_svg__c",
    x1: 4.558,
    x2: 14.738,
    y1: 14.749,
    y2: 1.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#636F7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADDE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "card_svg__d",
    x1: 4.558,
    x2: 14.738,
    y1: 14.749,
    y2: 1.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#0DD149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3F4D3"
  })))));
};
export default SvgCard;